export default {
  //localhost
  // API_URL: "http://localhost:3000",
  //test
  //API_URL: 'https://cts-api.herokuapp.com'
  //produccion
  API_URL: "https://api.acrosstech.cloud/cts-public",
};
